import { leadOwnersService } from '../services/leadOwners.service';

const state = {
  owners: []
};

const actions = {
  getData({ dispatch, commit }) {
    return leadOwnersService.getLeadOwners()
      .then(data => {
        commit('changeOwners', {
          data
        });
      })
      .catch(() => dispatch('alert/error', 'Unable to get lead owners data', { root: true }));
  }
};

const mutations = {
  changeOwners(state, payload) {
    state.owners = payload.data.data;
  }
};

export const leadOwners = {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/leadOwners.module.js